import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */

const SvgStep6 = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    viewBox="0 0 32 32"
    ref={svgRef}
    {...props}
  >
    <circle cx={16} cy={16} r={15} stroke="#DFE1E6" strokeWidth={2} />
    <path
      fill="currentColor"
      d="M16.2 21.792c-.704 0-1.328-.101-1.872-.304a3.353 3.353 0 01-1.376-.944c-.373-.437-.661-.992-.864-1.664-.192-.672-.288-1.472-.288-2.4v-.32c0-1.067.112-1.973.336-2.72.224-.757.539-1.376.944-1.856a3.52 3.52 0 011.44-1.04 4.95 4.95 0 011.84-.336c1.035 0 1.872.219 2.512.656.64.437 1.03 1.163 1.168 2.176H17.8c-.213-.544-.72-.816-1.52-.816-.31 0-.597.048-.864.144-.256.085-.485.25-.688.496-.192.235-.347.56-.464.976-.117.416-.192.95-.224 1.6.139-.213.31-.39.512-.528.203-.15.421-.267.656-.352.245-.096.496-.165.752-.208.267-.043.533-.064.8-.064 1.13 0 2 .31 2.608.928.608.608.912 1.472.912 2.592v.176c0 .565-.101 1.083-.304 1.552a3.62 3.62 0 01-.848 1.216 3.66 3.66 0 01-1.28.768 4.813 4.813 0 01-1.648.272zm-.16-2.016c.576 0 1.024-.16 1.344-.48.33-.33.496-.752.496-1.264v-.16c0-.512-.165-.928-.496-1.248-.32-.32-.768-.48-1.344-.48-.576 0-1.03.16-1.36.48-.32.32-.48.736-.48 1.248v.16c0 .512.16.933.48 1.264.33.32.784.48 1.36.48z"
    />
  </svg>
));
SvgStep6.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgStep6;
